import { render, staticRenderFns } from "./CampaignScroll.vue?vue&type=template&id=04c45ae0&"
import script from "./CampaignScroll.vue?vue&type=script&lang=ts&"
export * from "./CampaignScroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports